const DEFAULT_PREFIX = '_FPCannon_';

const ZHENGCAI_TOKEN_COOKIE_KEY = '_masontekweb_token'
const ZHENGCAI_USERINFO_COOKIE_KEY = '_masontekweb_userinfo'
// initial state
const state = {
    beforeLoginURLKey: DEFAULT_PREFIX + 'beforeLoginURL',
    opsBeforeLoginURLKey: DEFAULT_PREFIX + 'opsBeforeLoginURL',
    userTokenKey: DEFAULT_PREFIX + 'token',
    opsKey: DEFAULT_PREFIX + 'ops',
    zcTokenKey: ZHENGCAI_TOKEN_COOKIE_KEY,
    zcUserInfoKey: ZHENGCAI_USERINFO_COOKIE_KEY
}

// getters
const getters = {
    
}

// actions
const actions = {
    
}

// mutations
const mutations = {
    
}
  
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/cookie.js